import { Backdrop, Box, ButtonGroup, Button as ButtonI, CircularProgress, Grid } from '@mui/material';
import InputForm from '../../../InputT';
import SearInputM from '../../../SearchModal';
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import { ColumnsType } from 'antd/es/table';
import Table from '../../../TableResizable';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import EventIcon from '@mui/icons-material/Event';
import SweetAlert from "sweetalert2";
import { useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../Models/Utilisateur';
import React, { useEffect, useState } from 'react';
import ExcelIcon from '../../../../Res/ExcelIcon.svg';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import ReformatNumber from '../../../../Functions/Traitement/ReformatNumber';
import DataHistoCpt from '../../../../Types/DataHistoCpt';
import Data from '../../../../Data/Data.json';
import { Form, Input, Space } from 'antd';
import SelectOption from '../../../SelectOption';
import DataSelect from '../../../../Types/DataSelect';


let searchAgence: ParamsPicklist = { CodeAgence: "", Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: "101", Choix: 22 }


  const dataOption: DataSelect[] = [
  { label: "0--Toutes les opérations", value: "0" },
  { label: "1--Encours de validation", value: "1" },
  { label: "2--Opérations rejetées", value: "2" },
  { label: "3--Opérations validées", value: "3" },
 // { label: "5--ALL", value: "5" }
]
const columnsHistorique: ColumnsType<DataHistoCpt> = [
  {
    title: 'Date Opération ',
    dataIndex: 'DATOPE',
    ellipsis: true,
    width: 100,
    align: 'left',

  },
  {
    title: 'Heure',
    dataIndex: 'TIME',
    ellipsis: true,
    width: 100,
    align: 'left',
  },
  {
    title: 'Numéro compte',
    dataIndex: 'NUMCPT',
    ellipsis: true,
    width: 150,
    align: 'left',
  },
  // {
  //   title: 'Date Valeur',
  //   dataIndex: 'DEDEVR',
  //   ellipsis: true,
  //   width: 100,
  //   align: 'left',
  // },
  {
    title: 'Ref Automatique',
    dataIndex: 'REPECE',
    ellipsis: true,
    width: 130,
    align: 'left',
  },
  {
    title: 'Ref Manuelle',
    dataIndex: 'NUMRAP',
    ellipsis: true,
    width: 120,
    align: 'left',
  },
  {
    title: 'Libelle',
    dataIndex: 'LIBELL',
    ellipsis: true,
    width: 200,
  },
  {
    title: 'Montant',
    dataIndex: 'MONTAN',
    ellipsis: true,
    width: 100,
    align:"right"
  },
  {
    title: 'Sens opération',
    dataIndex: 'SENSEC',
    ellipsis: true,
    width: 100,
  },
  {
    title: 'Beneficiare',
    dataIndex: 'NBENEF',
    ellipsis: true,
    width: 120,
  },
  {
    title: 'Utisai',
    dataIndex: 'UTISAI',
    ellipsis: true,
    width: 70,
  }
  ,
  {
    title: 'Status',
    dataIndex: 'cdetat',
    ellipsis: true,
    width: 70,
  }

];

const Tab1 = (props: { form?: any, data: any[] }) => {

  // USER SESSION
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));

  const [start, setstart] = useState(false);
  const [loading, setLoading] = useState(false);
  const [DataExcel, SetDataExcel] = useState<any[]>([]);

  const _exporterBackOffice = React.createRef<ExcelExport>();

  const handleExport = () => {
    setLoading(false);
  }


  useEffect(() => {
    if (start == false) {
      props.form.setFieldValue("DateFin", user.datjour);
      props.form.setFieldValue("DateDebut", user.datjour);
      setstart(true)
    }
  }, []);


  const exportExcel = () => {
    if (props.data.length === 0) {
      SweetAlert.fire({ title: "Aucune donnée à exporter", icon: "warning" });
      return;
    }

    setLoading(true);

    const rows: any[] = props.data.map((data: any, indice: number) => ({
      key: indice,
      DATOPE: data.DATOPE,
      TIME: data.TIME,
      NUMCPT: data.NUMCPT,
      DEDEVR: data.DEDEVR,
      REPECE: data.REPECE,
      NUMRAP: data.NUMRAP,
      LIBELL: data.LIBELL,
      MONTAN: ReformatNumber(data.MONTAN || 0),
      NBENEF: data.NBENEF,
      UTISAI: data.UTISAI,
      UTIVAL: data.UTIVAL,
      cdetat: data.cdetat,
      SENSEC: data.SENSEC
    }));

    const totalMontant = rows.reduce((acc: number, cur: any) => acc + ReformatNumber(cur.MONTAN || 0), 0);

    rows.push({
      key: 'total',
      DATOPE: 'TOTAL',
      LIBELL: 'TOTAL MONTANT',
      MONTAN: totalMontant
    });

    rows.push({
      key: 'count',
      DATOPE: 'NB',
      LIBELL: `${props.data.length} opération(s)`,
      MONTAN: props.data.length
    });

    SetDataExcel(rows);

    if (!_exporterBackOffice.current) {
      setLoading(false);
      return;
    }

    setTimeout(() => {
      _exporterBackOffice.current?.save();
    }, 0);
  };



  return (
    <div className='tabItem'>
      <Box  className='border' width={"85%"} position={"absolute"}>
        
        <Box fontStyle="inherit" className='bordure1' >
          <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={7} lg={7}>
              <SearInputM defaultCode={user.codage} defaultLibelle={user.agence} disabled={true}  Titre={"Recherche D'agence"} label={"Agence"} name={"Agence"} Parametre={searchAgence} form={props.form} />   
              </Grid> 
              <Grid item xs={12} sm={12} md={5} lg={5}>
             <SelectOption  Option={dataOption}  label="Status opération" Size={'middle'} name="TypeOpe" />
             </Grid>
         </Grid>
        </Box>
         <Box fontStyle="inherit" className='bordure1' style={{ display: 'flex' }}>
           <Grid container spacing={0}>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <InputForm icon={<EventIcon color='success' />} label={" Date Debut"} name={"DateDebut"} type='date' />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
              <InputForm icon={<EventBusyIcon color='info' />} label={"Date Fin"} name={'DateFin'} type='date' />
              </Grid>
               <Grid item xs={12} sm={12} md={4} lg={4}>
              <ButtonGroup disableElevation color='success' variant="outlined" aria-label="Disabled elevation buttons">
                <ButtonI disabled={props.data.length >= 1 ? false : true} onClick={exportExcel}>
                  <img  src={ExcelIcon}></img> </ButtonI>
              </ButtonGroup>
              </Grid>
           </Grid>
         </Box>

        <Box fontStyle="inherit" className='bordure1' >
            <Table size='small' style={{ width: 'auto' }} columns={columnsHistorique} dataSource={props.data} scroll={{ y: 320, x: 1200 }} />
          </Box>

           <Box display={"flex"} fontStyle="inherit" className='bordure1'>
            
            <Space.Compact style={{ marginLeft: '5%' }} size="middle" >
              <Form.Item style={{ width: '70%' }} label="Total Débit / Nombre débit" name='TotalDebit'><Input disabled /></Form.Item>
              <Form.Item style={{ width: '14%' }} name='Nbrdebit'><Input disabled /></Form.Item>
            </Space.Compact>

            <Space.Compact style={{ marginLeft: '5%' }} size="middle" >
              <Form.Item style={{ width: '70%' }} label="Total Crédit / Nombre crédit" name='TotalCrebit'><Input disabled /></Form.Item>
              <Form.Item style={{ width: '14%' }} name='NbrCrebit'><Input disabled /></Form.Item>
            </Space.Compact>
          </Box>

       
      </Box>


      <ExcelExport  filterable data={DataExcel} fileName={"ListingNonComptabilise "+"_"+user.codage+"_"+user.coduti+"_"+Data.LocalVariable.appName+"_"+Date.now()+".xlsx"} ref={_exporterBackOffice} onExportComplete={handleExport}>
        <ExcelExportColumn field="DATOPE" title="Date Opération" locked={true} width={150} />
        <ExcelExportColumn field="TIME" title="Heure"  locked={true} width={70} />
        <ExcelExportColumn field="DEDEVR" title="Date De Valeur" width={100} />
        <ExcelExportColumn field="NUMCPT" title="NUMCPT" />
        <ExcelExportColumn field="REPECE" title="Reference" />
        <ExcelExportColumn field="NUMRAP" title="Ref Manuelle" />
        <ExcelExportColumn field="LIBELL" title="Libelle"  width={250} />
        <ExcelExportColumn field="MONTAN" title="MONTANT" />
        <ExcelExportColumn field="NBENEF" title="Beneficiare" />
      </ExcelExport>


      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>

  );

}

export default Tab1;